module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('ul', [_c('li', {
    staticClass: "wp-web"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://api.whatsapp.com/send?phone=908502224123"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Whatsapp")]), _vm._v(" "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfe2109e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 236
// module chunks = 1